import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import FetchFunc from "../API";
import close from "../asset/Close_round.png";
import "./Customerorders.css";

const formatAmount = (amountPaid) => {
    if (amountPaid === null || amountPaid === undefined) {
        return null;
    }
    const parsedAmount = Number(amountPaid);
    if (Number.isNaN(parsedAmount)) {
        return null;
    }
    return `$${(parsedAmount / 100).toFixed(2)}`;
};

const renderPaymentInfo = (order, className = 'order_status_info', compact = true) => {
    const amount = formatAmount(order?.amountPaid);
    const paymentIntentId = order?.paymentIntentId;
    const displayPaymentId = compact && paymentIntentId && paymentIntentId.length > 20
        ? `${paymentIntentId.substring(0, 20)}...`
        : paymentIntentId;

    if (!order?.paymentStatus && !amount && !paymentIntentId) {
        return null;
    }

    return (
        <div className={className}>
            {order.paymentStatus && (
                <p><strong>Payment Status:</strong> {order.paymentStatus}</p>
            )}
            {amount && (
                <p><strong>Amount:</strong> {amount}</p>
            )}
            {paymentIntentId && (
                <p><strong>Payment ID:</strong> {displayPaymentId}</p>
            )}
        </div>
    );
};

const EditPartnerOrderModal = ({ id, closeModal, refresh, setRefresh }) => {
    const navigate = useNavigate();
    const [partnerOrder, setPartnerOrder] = useState([]);
    const [emailLogs, setEmailLogs] = useState([]);
    const [emailLogsLoading, setEmailLogsLoading] = useState(false);
    const [emailLogsError, setEmailLogsError] = useState('');
    const [formData, setFormData] = useState({
        currentStatus: '',
        orderId: id,
        statusInfo: ''
    });

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await FetchFunc(
                    `/admin/getPartnerOrderInfo?orderId=${id}`,
                    'GET',
                );
                if (response === 401) {
                    localStorage.setItem('isLoggedIn', false);
                    localStorage.removeItem('username');
                    localStorage.removeItem('role');
                    localStorage.removeItem('userId');
                    localStorage.removeItem('email');
                    localStorage.removeItem('mobile');
                    navigate('/login');
                } else if (!response.ok) {
                    // console.log(response.text());
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                // console.log('Response from server:', response);
                const data = await response.json();
                // console.log('data response:', data);
                setPartnerOrder(data);
            } catch (error) {
                console.error('Error fetching orders:', error);
            }
        };
        fetchOrders();

        const fetchEmailLogs = async () => {
            setEmailLogsLoading(true);
            setEmailLogsError('');
            try {
                const response = await FetchFunc(
                    `/admin/order-email-logs?orderType=PARTNER&orderId=${id}&limit=50`,
                    'GET',
                );
                if (response.status === 401 || response.status === 403) {
                    localStorage.setItem('isLoggedIn', false);
                    localStorage.removeItem('username');
                    localStorage.removeItem('role');
                    localStorage.removeItem('userId');
                    localStorage.removeItem('email');
                    localStorage.removeItem('mobile');
                    navigate('/adminlogin');
                    return;
                }
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setEmailLogs(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error('Error fetching email logs:', error);
                setEmailLogsError('Failed to load email logs');
            } finally {
                setEmailLogsLoading(false);
            }
        };
        fetchEmailLogs();
    }, [navigate,id]);

    const formatLogTime = (value) => {
        if (!value) {
            return '-';
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return value;
        }
        return date.toLocaleString();
    };

    const hasPartnerDocuments = Boolean(
        partnerOrder.strataLevyNoticeFileKey || partnerOrder.authorityLetterFileKey
    );

    const handleDocumentDownload = async (fileKey, fileName) => {
        if (!fileKey) {
            return;
        }
        try {
            const params = new URLSearchParams({
                fileKey,
                fileName: fileName || 'partner-order-document',
            });
            const response = await FetchFunc(
                `/oss/partner-order-document?${params.toString()}`,
                'GET',
            );
            if (!response) {
                throw new Error('No response received while downloading document');
            }
            if (response.status === 401 || response.status === 403) {
                localStorage.setItem('isLoggedIn', false);
                localStorage.removeItem('username');
                localStorage.removeItem('role');
                localStorage.removeItem('userId');
                localStorage.removeItem('email');
                localStorage.removeItem('mobile');
                navigate('/adminlogin');
                return;
            }
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName || 'partner-order-document';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error('Failed to download partner document:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const dataToSend = {
            ...formData,
        };
        try {
            // console.log('data sent:', dataToSend);
            const response = await FetchFunc(
                '/admin/addPartnerOrderStatus',
                'POST',
                JSON.stringify(dataToSend)
            );
            if (response === 401) {
                localStorage.setItem('isLoggedIn', false);
                localStorage.removeItem('username');
                localStorage.removeItem('role');
                localStorage.removeItem('userId');
                localStorage.removeItem('email');
                localStorage.removeItem('mobile');
                navigate('/login');
            } else if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // console.log('Response from server:', response);
            setRefresh(!refresh);
            closeModal();
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };

    return (
        <div className="change_modal">
            <div className="change_order_modal_content">
            <div className="close_modal">
                    <img src={close} alt="close" onClick={closeModal} />
                </div>
                <h1>Order: {id}</h1>
                <div className="order_detail_info">
                    <p>Agent: {partnerOrder.agentFirstName} {partnerOrder.agentLastName}</p>
                    <p>Agent email: {partnerOrder.agentEmail}</p>
                    <p>Agent mobile: {partnerOrder.agentMobile}</p>
                    {partnerOrder.reportType && <p style={{ fontWeight: 'bold', color: '#008286' }}>Report Type: {partnerOrder.reportType}</p>}
                </div>
                {renderPaymentInfo(partnerOrder, 'order_payment_info', false)}
                <div className="partner_documents_section">
                    <h2>Order Documents</h2>
                    {!hasPartnerDocuments && <p className="partner_documents_hint">No uploaded documents</p>}
                    {partnerOrder.strataLevyNoticeFileKey && (
                        <div className="partner_document_item">
                            <div>
                                <strong>Strata Levy Notice</strong>
                                <p>{partnerOrder.strataLevyNoticeFileName}</p>
                            </div>
                            <button
                                type="button"
                                onClick={() => handleDocumentDownload(
                                    partnerOrder.strataLevyNoticeFileKey,
                                    partnerOrder.strataLevyNoticeFileName
                                )}
                            >
                                Download
                            </button>
                        </div>
                    )}
                    {partnerOrder.authorityLetterFileKey && (
                        <div className="partner_document_item">
                            <div>
                                <strong>Authority Letter</strong>
                                <p>{partnerOrder.authorityLetterFileName}</p>
                            </div>
                            <button
                                type="button"
                                onClick={() => handleDocumentDownload(
                                    partnerOrder.authorityLetterFileKey,
                                    partnerOrder.authorityLetterFileName
                                )}
                            >
                                Download
                            </button>
                        </div>
                    )}
                </div>
                <div className="email_logs_section">
                    <h2>Email Logs</h2>
                    {emailLogsLoading && <p className="email_logs_hint">Loading email logs...</p>}
                    {!emailLogsLoading && emailLogsError && <p className="email_logs_error">{emailLogsError}</p>}
                    {!emailLogsLoading && !emailLogsError && emailLogs.length === 0 && (
                        <p className="email_logs_hint">暂无邮件记录</p>
                    )}
                    {!emailLogsLoading && !emailLogsError && emailLogs.length > 0 && (
                        <div className="email_logs_list">
                            {emailLogs.map((log, index) => (
                                <div className="email_logs_item" key={`${log.id || 'log'}-${index}`}>
                                    <div className="email_logs_top">
                                        <span className="email_logs_time">{formatLogTime(log.createdAt)}</span>
                                        <span className={log.status === 'SENT' ? 'email_logs_status_ok' : 'email_logs_status_fail'}>
                                            {log.status}
                                        </span>
                                    </div>
                                    <p>{log.recipientRole} - {log.recipientEmail}</p>
                                    <p>{log.templateCode} / {log.triggerSource}</p>
                                    {log.errorMessage && <p className="email_logs_error_text">{log.errorMessage}</p>}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <form onSubmit={handleSubmit}>
                    <label>
                        Status:
                        <select
                            name="currentStatus"
                            value={formData.currentStatus}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Order Status</option>
                            <option value="Processing">Processing</option>
                            <option value="Completed">Complete</option>
                        </select>
                    </label>
                    <label>
                        History:
                        <input 
                            name="statusInfo"
                            value={formData.statusInfo}
                            onChange={handleChange}
                        />
                    </label>
                    <div className="confirm_change">
                        <button type="submit">Save</button>
                        <button type="button" onClick={closeModal}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const Partnerorders = () => {
    const [order, setOrder] = useState([]);
    const [filter, setFilter] = useState('COMPLETED');
    const [refresh, setRefresh] = useState(false);
    const navigate = useNavigate();
    const [activeOrderId, setActiveOrderId] = useState(null);
    const [id, setId] = useState('');
    const [address, setAddress] = useState('');
    const pageSize = 10
    const [currentPage, setCurrentPage] = useState(1);
    const [totalOrders, setTotalOrders] = useState(null);
    const totalPages = Math.ceil(totalOrders / pageSize);
    const [searchedOrder, setSearchedOrder] = useState([]);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                let response;
                if (filter) {
                    response = await FetchFunc(
                        `/admin/allPartnerOrders?status=${filter}&offset=${currentPage-1}&limit=${pageSize}`,
                        'GET',
                    );
                } else {
                    response = await FetchFunc(
                        `/admin/allPartnerOrders?offset=${currentPage-1}&limit=${pageSize}`,
                        'GET',
                    );
                }
                if (response.status === 401) {
                    localStorage.setItem('isLoggedIn', false);
                    localStorage.removeItem('username');
                    localStorage.removeItem('role');
                    localStorage.removeItem('userId');
                    localStorage.removeItem('email');
                    localStorage.removeItem('mobile');
                    navigate('/login');
                } else if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                // console.log('Response from server:', response);
                const data = await response.json();
                // console.log('data response:', data);
                setTotalOrders(data.totalElements);
                const sorted = data.content.slice().sort((a, b) => {
                    return new Date(b.createTime) - new Date(a.createTime);
                });
                setOrder(sorted);
            } catch (error) {
                console.error('Error fetching orders:', error);
            }
        };
        fetchOrders();
    }, [refresh, navigate, filter, currentPage, pageSize]);

    // const filteredOrders = order.filter(order => {
    //     if (filter === 'all') return true;
    //     return order.currentStatus.toLowerCase() === filter;
    // });

    const handleAddressSearch = (e) => {
        setAddress(e.target.value);
    }

    const handleIdSearch = (e) => {
        setId(e.target.value);
    }

    const handleSearch = async (e) => {
        e.preventDefault();
        const params = new URLSearchParams({
            orderId: id || '',
            address: address || '',
        });
        try {
            const response = await FetchFunc(
                `/partner-order/search?${params.toString()}`,
                'GET',
            );
            if (response.status === 401) {
                localStorage.setItem('isLoggedIn', false);
                localStorage.removeItem('username');
                localStorage.removeItem('role');
                localStorage.removeItem('userId');
                localStorage.removeItem('email');
                localStorage.removeItem('mobile');
                navigate('/adminlogin');
            } else if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();
            // console.log('data response:', data);
            setSearchedOrder(data);
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const formatToISO = (dateString) => {
        const [day, month, yearAndTime] = dateString.split('-');
        const [year, time] = yearAndTime.split(' ');
        return `${year}-${month}-${day}T${time}`;
    };

    const handleOpenModal = (orderId) => {
        // console.log(orderId)
        setActiveOrderId(orderId);
    };
    
    const handleCloseModal = () => {
        setActiveOrderId(null);
    };

    const handleRecordDownload = async () => {
        try {
            const response = await FetchFunc(
                '/admin/exportPartnerOrders',
                'GET',
            );
            if (response.status === 401) {
                localStorage.setItem('isLoggedIn', false);
                localStorage.removeItem('username');
                localStorage.removeItem('role');
                localStorage.removeItem('userId');
                localStorage.removeItem('email');
                localStorage.removeItem('mobile');
                navigate('/adminlogin');
            } else if (!response.ok) {
                // console.log(response.text());
            }
            // console.log('Response from server:', response);
            const blob = await response.blob();

            // Create a temporary URL for the blob
            const downloadUrl = window.URL.createObjectURL(blob);
    
            // Create a link element and trigger the download
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = order.reportName || 'downloaded_file';
            document.body.appendChild(link);
            link.click();
    
            // Cleanup: Remove the link and revoke the URL
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
            
        } catch (error) {
            console.error('Failed to update password:', error);
        }
    };

    return (
        <div className="orders">
            <div className="change_property_title">
                <h1>Orders</h1>
                <button onClick={handleRecordDownload} style={{width: '15rem'}}>Download Order Record</button>
            </div>
            <hr style={{background: '#DDD', width: '100%', border: 'none', height: '1px'}} />
            <div className="order_search">
                <input 
                    type="text"
                    value={id}
                    placeholder="Search order id"
                    onChange={handleIdSearch}
                />
                <input
                    type="text"
                    value={address}
                    placeholder="Search address"
                    onChange={handleAddressSearch}                    
                />
                <button onClick={handleSearch}>Search</button>
            </div>
            <div className="order_list">
                {Array.isArray(searchedOrder) && 
                    searchedOrder
                    .sort((a, b) => new Date(formatToISO(b.createTime)) - new Date(formatToISO(a.createTime)))
                    .map((order) => (
                    <div key={order.orderId} className="order_item">                        
                        <div className="order_detail">
                            <p>{order.createTime}</p>
                            <h1>Order #{order.orderId}</h1>
                            <h2>{order.info}</h2>
                            {order.reportType && <p style={{ fontWeight: 'bold', color: '#008286' }}>Report Type: {order.reportType}</p>}
                            {renderPaymentInfo(order)}
                        </div>
                        <div onClick={() => handleOpenModal(order.orderId)} className="edit_order">
                            Edit order
                        </div>
                        {activeOrderId === order.orderId && (
                            <EditPartnerOrderModal 
                                id={order.orderId}
                                closeModal={handleCloseModal}
                                refresh={refresh}
                                setRefresh={setRefresh}
                            />
                        )}
                    </div>
                ))}
                <hr style={{background: '#DDD', width: '100%', border: 'none', height: '1px'}} />
            </div>
            <div className="order_status">
                <span 
                    onClick={() => setFilter('')}
                    className={filter === '' ? 'active' : ''}
                >All</span>
                <span 
                    onClick={() => setFilter('PENDING_PAYMENT')}
                    className={filter === 'PENDING_PAYMENT' ? 'active' : ''}
                >Pending Payment</span>
                <span 
                    onClick={() => setFilter('PAID')}
                    className={filter === 'PAID' ? 'active' : ''}
                >Paid</span>
                <span 
                    onClick={() => setFilter('PROCESSING')}
                    className={filter === 'PROCESSING' ? 'active' : ''}
                >Processing</span>
                <span 
                    onClick={() => setFilter('COMPLETED')}
                    className={filter === 'COMPLETED' ? 'active' : ''}
                >Completed</span>
            </div>
            <div className="order_list">
                {order
                .sort((a, b) => new Date(formatToISO(b.createTime)) - new Date(formatToISO(a.createTime)))
                .map((order) => (
                    <div key={order.orderId} className="order_item">                        
                        <div className="order_detail">
                            <p>{order.createTime}</p>
                            <h1>Order #{order.orderId}</h1>
                            <h2>{order.info}</h2>
                            {order.reportType && <p style={{ fontWeight: 'bold', color: '#008286' }}>Report Type: {order.reportType}</p>}
                            {renderPaymentInfo(order)}
                            <p>{order.url}</p>
                        </div>
                        <div onClick={() => handleOpenModal(order.orderId)} className="edit_order">
                            Edit order
                        </div>
                        {activeOrderId === order.orderId && (
                            <EditPartnerOrderModal 
                                id={order.orderId}
                                closeModal={handleCloseModal}
                                refresh={refresh}
                                setRefresh={setRefresh}
                            />
                        )}
                    </div>
                ))}
            </div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center', gap: '5px'}}>
                <button
                    onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                >
                    Last Page
                </button>
                {[...Array(totalPages)].map((_, idx) => {
                    const page = idx + 1;
                    return (
                        <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            style={{
                                fontWeight: page === currentPage ? 'bold' : 'normal',
                            }}
                        >
                            {page}
                        </button>
                    );
                })}
                <button
                    onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                    disabled={currentPage === totalPages}
                >
                    Next Page
                </button>
            </div>
        </div>
    );
};

export default Partnerorders;
